import { useNavigate } from 'react-router-dom';

import { useFormik } from 'formik';

import { createAiModel } from 'api/Admin/intelligence/models';

import { useCustomMutation } from 'lib/hooks/useCustomMutation';

import Button from 'components/shared/Buttons/Button';
import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Modal from 'components/shared/Modal/Modal';

import { IntelligenceModelValidationSchema } from '../lib/IntelligenceModelValidationSchema';

import NewIntelligenceModelInput from './NewIntelligenceModelInput';

const NewIntelligenceModelModal = ({ isOpen, onModalClose }) => {
  const navigate = useNavigate();
  const { mutate } = useCustomMutation({
    mutationFn: (params) => createAiModel(navigate, params),
    successMessage: 'Successfully created new model!',
    invalidateQueryKey: 'ai_models',
    onSuccess: () => {
      formik.resetForm();
      onModalClose();
    }
  });

  const formik = useFormik({
    initialValues: {
      name: '',
      path: '',
      host: '',
      version: ''
    },
    enableReinitialize: true,
    validationSchema: IntelligenceModelValidationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      mutate({
        model: values
      });
      setSubmitting(false);
    }
  });
  return (
    <Modal
      isOpen={isOpen}
      handleClose={onModalClose}
      title="New Model"
      slideFromRight
      footer={
        <div className="flex w-full justify-between">
          <Button outlined color="neutral" text="Close" onClick={onModalClose} />
          <Button outlined color="primary" text="Submit" onClick={formik.submitForm} />
        </div>
      }>
      <div className="grid grid-cols-2 gap-2">
        <NewIntelligenceModelInput formik={formik} target="name" label="Name" />
        <NewIntelligenceModelInput formik={formik} target="path" label="Path" />
        <NewIntelligenceModelInput formik={formik} target="host" label="Host" />
        <NewIntelligenceModelInput formik={formik} target="version" label="Version" />
      </div>
    </Modal>
  );
};

export default withErrorBoundary(NewIntelligenceModelModal);
